/**
 * RECENT ROLES card section (STN client round 2026-08): top CARD_ROLE_COUNT
 * employment roles from MAPS.PersonJob, a "+ N earlier roles" link into the experience
 * drawer when more exist, and the no-verified-history copy when none do.
 * Pure display — slicing/formatting lives in utils/recent-roles.ts.
 */
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import type { MapsEmploymentRole } from '../../models/maps.types';
import { EarlierRoleCount, FormatRoleMeta, TopRoles } from '../../utils/recent-roles';

interface RoleRow {
    title: string | null;
    meta: string | null;
}

@Component({
    selector: 'maps-recent-roles',
    standalone: false,
    template: `
        <section class="roles" aria-label="Recent roles">
            <header>Recent Roles</header>
            <ul *ngIf="rows.length > 0; else empty">
                <li *ngFor="let r of rows">
                    <span class="dot" aria-hidden="true"></span>
                    <span class="detail">
                        <span class="title" *ngIf="r.title">{{ r.title }}</span>
                        <span class="meta" *ngIf="r.meta">{{ r.meta }}</span>
                    </span>
                </li>
            </ul>
            <button
                *ngIf="earlierCount > 0"
                type="button"
                class="more"
                data-testid="earlier-roles"
                (click)="moreClicked.emit()">
                + {{ earlierCount }} earlier {{ earlierCount === 1 ? 'role' : 'roles' }}
            </button>
            <ng-template #empty>
                <p class="none">No verified work history on file — contact them directly for details.</p>
            </ng-template>
        </section>
    `,
    styleUrl: './recent-roles.component.scss',
})
export class RecentRolesComponent implements OnChanges {
    @Input() roles: MapsEmploymentRole[] | null | undefined = null;
    /** "+ N earlier roles" click — the card opens the experience drawer. */
    @Output() moreClicked = new EventEmitter<void>();

    rows: RoleRow[] = [];
    earlierCount = 0;

    ngOnChanges(): void {
        this.rows = TopRoles(this.roles).map((r) => ({
            title: r.jobTitle?.trim() || null,
            meta: FormatRoleMeta(r),
        }));
        this.earlierCount = EarlierRoleCount(this.roles);
    }
}
